/**
 * INTERNAL — popup watermark display (text, logo, links). Not shown in merchant UI.
 * Show/hide per store: API `watermark.enabled` from shop.hideWatermark (server).
 */

export const WATERMARK_CONFIG = {
  text: "Powered by WeUpsell",
  logoUrl:
    "https://pub-bf6c83729841477e8edf540e43c2a97f.r2.dev/weupsell_1743677911228.avif",
  position: "bottom-right",
  offsetGap: 12,
  liveUrl: "https://weupsell.com",
  editorContact: {
    preferred: "whatsapp",
    whatsappWaMeId: "917990488965",
    whatsappMessage:
      "Hi WeUpsell team — I'd like help removing or upgrading the popup watermark on my store.",
    email: "team@weupsell.com",
    emailSubject: "Remove WeUpsell popup watermark",
    emailBody:
      "Hi,\n\nI'd like to remove or customize the \"Powered by WeUpsell\" badge on my popups.\n\nMy store:",
  },
};
